

<template>
  <div class="course-index-container section columns is-multiline" v-if="courses">
    <router-link
      :to="'/courses/' + course.id.toString()"
      class="course-index-link column container is-6"
      v-for="(course, courseIndex) in courses"
      :key="courseIndex"
    >
      <div
        class="course-index-box has-text-centered"
        :style="{backgroundImage:'url('+ placeHolderBackgrounds[0] +')'}"
      >
        <h3 class="has-text-centered is-size-4 is-overlay">{{ course.name }}</h3>
      </div>
    </router-link>
    <!-- <router-link
      :to="'/courses/' + course.id.toString()"
      class="course-index-link column container is-one-third"
      v-for="(course, courseIndex) in courses"
      :key="courseIndex"
    >
      <div
        class="course-index-box has-text-centered"
        :style="{backgroundImage:'url('+ placeHolderBackgrounds[1] +')'}"
      >
        <h3 class="has-text-centered is-size-4 is-overlay">{{ course.name }}</h3>
      </div>
    </router-link>
    <router-link
      :to="'/courses/' + course.id.toString()"
      class="course-index-link column container is-one-third"
      v-for="(course, courseIndex) in courses"
      :key="courseIndex"
    >
      <div
        class="course-index-box has-text-centered"
        :style="{backgroundImage:'url('+ placeHolderBackgrounds[2] +')'}"
      >
        <h3 class="has-text-centered is-size-4 is-overlay">{{ course.name }}</h3>
      </div>
    </router-link>
    <router-link
      :to="'/courses/' + course.id.toString()"
      class="course-index-link column container is-one-third"
      v-for="(course, courseIndex) in courses"
      :key="courseIndex"
    >
      <div
        class="course-index-box has-text-centered"
        :style="{backgroundImage:'url('+ placeHolderBackgrounds[3] +')'}"
      >
        <h3 class="has-text-centered is-size-4 is-overlay">{{ course.name }}</h3>
      </div>
    </router-link>
    <router-link
      :to="'/courses/' + course.id.toString()"
      class="course-index-link column container is-one-third"
      v-for="(course, courseIndex) in courses"
      :key="courseIndex"
    >
      <div
        class="course-index-box has-text-centered"
        :style="{backgroundImage:'url('+ placeHolderBackgrounds[4] +')'}"
      >
        <h3 class="has-text-centered is-size-4 is-overlay">{{ course.name }}</h3>
      </div>
    </router-link>
    <router-link
      :to="'/courses/' + course.id.toString()"
      class="course-index-link column container is-one-third"
      v-for="(course, courseIndex) in courses"
      :key="courseIndex"
    >
      <div
        class="course-index-box has-text-centered"
        :style="{backgroundImage:'url('+ placeHolderBackgrounds[5] +')'}"
      >
        <h3 class="has-text-centered is-size-4 is-overlay">{{ course.name }}</h3>
      </div>
    </router-link>-->
  </div>
</template>

<script>
import { CourseClient } from "../../clients/CourseClient";
import BaseHelper from "../../helpers/BaseHelper";

export default {
  mixins: [BaseHelper],
  data() {
    return {
      courses: null,
      placeHolderBackgrounds: [
        "https://live.staticflickr.com/5832/22700427437_b9f37021ed_b.jpg",
        "https://live.staticflickr.com/5750/22497564513_4eb9dfa558_b.jpg",
        "https://handluggageonly.co.uk/wp-content/uploads/2018/01/Hand-Luggage-Only-11-4.jpg",
        "https://handluggageonly.co.uk/wp-content/uploads/2018/01/Hand-Luggage-Only-35.jpg",
        "https://images.ctfassets.net/wqz0jxyfamgk/fsvzWWjGDu44MOKgcKYce/f23a48017747661247c103434d032397/Cambridge_4.jpg.crdownload.jpg?fm=jpg&w=1280&h=720&fl=progressive&q=85",
        "https://handluggageonly.co.uk/wp-content/uploads/2018/01/Hand-Luggage-Only-3-5.jpg"
      ]
    };
  },

  mounted() {
    this.$store.dispatch(
      "loader/show",
      "Fetching available courses for you...."
    );
    CourseClient.getCourses()
      .then(response => {
        this.courses = response.data.courses;
        this.$store.dispatch("loader/hide");
      })
      .catch(err => {
        this.$store.dispatch("loader/hide");
      });
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
@import "../../assets/scss/courses/index.scss";
</style>

